import { useLocation } from "react-router-dom";
import data from "./style_json";
import { use, useEffect, useState } from "react";
import swal from "sweetalert";
import usePost from "../../hooks/usePost";
import useGetById from "../../hooks/useGetById";
import useDelete from "../../hooks/useDelete";
import JSZip, { forEach } from "jszip";

const PRODUCT_KEY = "shirt";

const useFormStyle = () => {
  const location = useLocation();
  const [listData, setListData] = useState(data);
  const [fileZip, setFileZip] = useState(null);
  const [detailFabric, setDetailFabric] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalAsset, setIsModalAsset] = useState(false);
  const [isModalDetail, setIsModalDetail] = useState(false);
  const [form, setForm] = useState([]);
  const [allImages, setAllImages] = useState([]);
  const [asset, setAsset] = useState(null);
  const [index, setIndex] = useState(0);

  const {
    isLoading: isLoadingDelete,
    error: errorDelete,
    handleDelete: handleDeletes,
  } = useDelete();

  const {
    isLoading: isLoadingSubmit,
    error,
    isSuccess,
    navigate,
    handlePost,
  } = usePost();

  const {
    data: dataById,
    error: errGetById,
    isLoading: isLoadingById,
    handleGetAllStyle,
    handleFetchData,
  } = useGetById(
    `/v1/custom/products/${PRODUCT_KEY}/fabrics/${location.state._id}/assets`,
  );

  useEffect(() => {
    setDetailFabric(location.state);
    handleInitForm();
  }, []);

  useEffect(() => {
    if (detailFabric) {
      handleInitForm();
    }
    handleFetchData();
  }, [data]);

  useEffect(() => {}, [index]);

  // useEffect(() => {
  // if (dataById) {

  //     for (let i = 0; i < listData.length; i++) {
  //         const element = listData[i];
  //         for (let ind = 0; ind < element.data.length; ind++) {
  //             const elements = element.data[ind];
  //             if (dataById.find(d => d.code === elements.code)) {
  //                 const dt = dataById.find(d => d.code === elements.code);
  //                 elements.file = dt.file
  //                 elements.id = dt._id
  //             }
  //         }
  //     }
  //     getAllImages()
  // }

  // }, [isLoadingById])
  useEffect(() => {
    getAllImages();
  }, [listData]);

  useEffect(() => {
    var result = [];
    dataById.forEach((item) => {
      let style = item.style;
      let itemName = item.name;

      if (!style && item.code) {
        const parts = item.code.split("__");
        if (parts.length > 2) {
          style = parts[2].split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
        }
      }
      
      if (!itemName && item.code) {
        const parts = item.code.split("__");
        if (parts.length > 3) {
          itemName = parts.slice(3).join(" ").split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
        } else {
          itemName = parts[parts.length - 1];
        }
      }

      let existingStyle = result.find((styleItem) => styleItem.name === style);
      if (!existingStyle) {
        let iconImage = null;
        try {
          iconImage = require(`../../assets/icons/${(style || "").toLowerCase()}/${(style || "").toLowerCase()}.svg`);
        } catch (err) {
          try {
            iconImage = require(`../../assets/icons/button/button.svg`);
          } catch (err2) {
            iconImage = null;
          }
        }
        existingStyle = {
          name: style,
          image: iconImage,
          folded: [],
          front: [],
          back: [],
        };
        result.push(existingStyle);
      }
      
      if (item.pov === "FOLDED") {
        existingStyle.folded.push({
          name: itemName,
          image: null, // Anda dapat mengisi image dengan nilai yang sesuai
          isHover: false,
          file: item.file,
          id: item._id,
          code: item.code,
        });
      } else if (item.pov === "FRONT") {
        existingStyle.front.push({
          name: itemName,
          image: null, // Anda dapat mengisi image dengan nilai yang sesuai
          isHover: false,
          file: item.file,
          id: item._id,
          code: item.code,
        });
      } else if (item.pov === "BACK") {
        existingStyle.back.push({
          name: itemName,
          image: null, // Anda dapat mengisi image dengan nilai yang sesuai
          isHover: false,
          file: item.file,
          id: item._id,
          code: item.code,
        });
      }
    });

    setListData(result);
  }, [isLoadingById, dataById]);

  const getAllImages = () => {
    const allImg = [];
    const arrayToCheck = ["data", "front", "back", "folded"];

    for (let i = 0; i < listData.length; i++) {
      const element = listData[i];

      arrayToCheck.forEach((arrayName) => {
        if (element[arrayName] && Array.isArray(element[arrayName])) {
          for (let ind = 0; ind < element[arrayName].length; ind++) {
            const item = element[arrayName][ind];
            if (item.file !== "") {
              allImg.push({
                image: item.file,
                name: item.name,
                code: item.code,
                category: element.name,
                view: arrayName,
              });
            }
          }
        }
      });
    }

    setAllImages(allImg);
  };

  const handleInitForm = () => {
    const allData = [];

    listData.forEach((category) => {
      const arrayToCheck = ["data", "front", "back", "folded"];

      arrayToCheck.forEach((arrayName) => {
        if (category[arrayName] && Array.isArray(category[arrayName])) {
          category[arrayName].forEach((item) => {
            allData.push({
              style: category.name,
              name: item.name,
              code: item.code,
              files: null,
              view: arrayName,
            });
          });
        }
      });
    });

    setForm(allData);
  };

  const handleHover = (e, type) => {
    e.isHover = type;
    const newListData = [...listData];
    setListData(newListData);
  };

  const handleBulkUploadOpen = () => {
    setIsModal(true);
  };

  const handleAssetUploadOpen = (ex) => {
    setIsModalAsset(true);
    setAsset(ex);
  };

  const handleBulkUploadClose = () => {
    setIsModal(false);
  };

  const handleAssetUploadClose = () => {
    setIsModalAsset(false);
    setAsset(null);
  };

  const handleDetailClose = () => {
    setIsModalDetail(false);
  };

  const removeExtension = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex === -1) return fileName; // No extension found
    return fileName.substring(0, lastDotIndex);
  };

  const removePath = (filePath) => {
    const fileName = filePath.split("/");
    return fileName[fileName.length - 1];
  };

  const handleImageChange = (img) => {
    const files = Array.from(img.target.files);
    for (let i = 0; i < form.length; i++) {
      const element = form[i];
      element.files = files.find(
        (file) => removeExtension(file.name) === element.code,
      );
    }

    for (let i = 0; i < listData.length; i++) {
      const element = listData[i];
      const arrayToCheck = ["data", "front", "back", "folded"];

      arrayToCheck.forEach((arrayName) => {
        if (element[arrayName] && Array.isArray(element[arrayName])) {
          for (let ind = 0; ind < element[arrayName].length; ind++) {
            const item = element[arrayName][ind];
            const matchingFile = files.find(
              (file) => removeExtension(file.name) === item.code,
            );
            if (matchingFile) {
              item.file = window.URL.createObjectURL(matchingFile);
            }
          }
        }
      });
    }

    setIsChange(true);
    getAllImages();
    setIsModal(false);
  };
  useEffect(() => {
    if (fileZip) {
      handleSubmitZip();
    }
  }, [fileZip]);

  const handleBulkUploadZip = async (file) => {
    try {
      const zip = await JSZip.loadAsync(file);
      const matchingEntries = [];

      zip.forEach((relativePath, zipEntry) => {
        // Skip Mac-specific files and directories
        if (
          zipEntry.name.includes("__MACOSX") ||
          zipEntry.name.endsWith(".DS_Store") ||
          zipEntry.dir
        ) {
          return;
        }

        const ext = zipEntry.name.split('.').pop().toLowerCase();
        if (!["svg", "png", "webp"].includes(ext)) {
          return;
        }

        matchingEntries.push({ zipEntry });
      });

      const filePromises = matchingEntries.map(async ({ zipEntry }) => {
        try {
          const blob = await zipEntry.async("blob");
          const fileObj = new File([blob], zipEntry.name, { type: blob.type });
          return { files: fileObj };
        } catch (error) {
          console.error("Error processing zip entry:", error);
          return { error: error.message, zipEntryName: zipEntry.name };
        }
      });

      const processedFiles = await Promise.all(filePromises);

      const validFiles = processedFiles.filter((file) => !file.error);
      const erroredFiles = processedFiles.filter((file) => file.error);

      if (validFiles.length > 0) {
        setFileZip(validFiles);
      }

      if (erroredFiles.length > 0) {
        console.warn("Errored Files:", erroredFiles);
      }
    } catch (error) {
      console.error("Error handling bulk upload:", error);
    }
  };

  const handleImageChangeAsset = (img) => {
    const files = img.target.files[0];

    for (let i = 0; i < form.length; i++) {
      const element = form[i];
      if (element.code === asset.code) {
        element.files = files;
      }
    }

    for (let i = 0; i < listData.length; i++) {
      const element = listData[i];
      for (let ind = 0; ind < element.data.length; ind++) {
        const elements = element.data[ind];

        if (elements.code === asset.code) {
          elements.file = window.URL.createObjectURL(files);
        }
      }
    }
    setIsChange(true);
    getAllImages();
    setIsModalAsset(false);
  };

  const handleDetail = (ex) => {
    allImages.forEach((d, i) => {
      if (d.name === ex.name) {
        setIndex(i);
      }
    });
    setIsModalDetail(true);
  };
  const handleDelete = (ex) => {
    swal({
      text: "Deleted data will disappear from the system",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        ex.file = "";
        if (ex.id) {
          let params = {
            url: `/v1/style?id=${ex.id}`,
            descSuccess: "Asset data has been successfully deleted.",
          };
          handleDeletes(params);
        } else {
          swal(
            "Deleted!",
            "Asset data has been successfully deleted.",
            "success",
            {
              button: "Close",
            },
          );
        }
        getAllImages();
      }
    });
  };

  const handleCancelChange = () => {
    window.location.reload();
  };

  useEffect(() => {
    setIsLoading(isLoadingSubmit);
  }, [isLoadingSubmit]);

  const handleSubmitZip = () => {
    const formData = new FormData();
    fileZip.forEach((f) => {
      if (f.files) {
        formData.append(`files`, f.files);
      }
    });

    let params = {
      url: `/v1/custom/products/${PRODUCT_KEY}/fabrics/${location.state._id}/assets/bulk`,
      form: formData,
      titleSuccess: "Saved!",
      descSuccess: "Aset berhasil disimpan ke data development.",
      type: "multipart/form-data",
    };

    handlePost(params);
    setIsModal(false);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    form.forEach((f) => {
      if (f.files === null || f.files === undefined || f.files === "") {
      }
      if (f.files) {
        formData.append(`style`, f.style);
        formData.append(`name`, f.name);
        formData.append(`files`, f.files);
        formData.append(`code`, f.code);
        formData.append(`pov`, f.pov);
      }
    });
    let params = {
      url: `/v1/style?fabric_id=${location.state._id}`,
      form: formData,
      titleSucces: "Saved!",
      descSuccess: "Style has been successfully saved.",
      type: "multipart/form-data",
    };

    handlePost(params);
    debugger;
  };

  return {
    form,
    isModal,
    isModalDetail,
    isModalAsset,
    isChange,
    isLoading,
    detailFabric,
    listData,
    allImages,
    index,
    fileZip,
    handleHover,
    handleBulkUploadOpen,
    handleBulkUploadClose,
    handleAssetUploadOpen,
    handleAssetUploadClose,
    handleImageChange,
    handleBulkUploadZip,
    handleImageChangeAsset,
    handleDetail,
    handleDetailClose,
    handleDelete,
    handleCancelChange,
    handleSubmitZip,
    handleSubmit,
  };
};
export default useFormStyle;
